import React, { useState } from 'react';
import { snakeCase } from 'lodash';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import CtaButton from '../../../../components/elements/CtaButton';
import { SectionPaddingSide, SectionPaddingVertical } from '../../../../components/global/Layout';
import { sendAnalyticsEvent } from '../../../../services/analytics';
import Question from './Question';
import { QUESTION_ID } from './constants';

const styles = require('./Quiz.module.css');

const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/accounts`;

const data = {
  title: 'Let’s Crack the Code on Your Child’s Learning Style',
  body:
    'codeSpark is designed to teach your child code through a unique mix of structured lessons, interactive puzzles & challenges, and creative space. Take this quiz to discover how your kid-coder will conquer coding best.',
  foos: [
    // Add ?v=2 to temp disable cloudfront cache until chris comes back
    { src: 'Woz_blob_head.svg?v=2', alt: 'The Tinkerer' },
    { src: 'Sarge_blob_head.svg?v=2', alt: 'The Creative' },
    { src: 'Gracie_blob_head.svg?v=2', alt: 'The Problem Solver' },
    { src: 'Naomi_blob_head.svg', alt: 'The Collaborator' },
  ],
  ctaLabel: 'START QUIZ',
};

function QuizSection({ onCtaClick }) {
  const [selectedOption, setSelectedOption] = useState();
  const { foos, title, body, ctaLabel } = data;

  const handleClick = e => {
    sendAnalyticsEvent('web_onboarding_quiz_question_answered', {
      app: 'web-site',
      question_name: snakeCase(QUESTION_ID),
      screen_name: 'homepage',
    });

    onCtaClick(e, 'quiz_module', {
      questionId: QUESTION_ID,
      answer: selectedOption,
    });
  };

  return (
    <SectionPaddingVertical className={styles.quizSection}>
      <SectionPaddingSide>
        <div className="grid-x grid-margin-x">
          <div className={`cell medium-12 large-6 ${styles.quizSectionInner}`}>
            <CodeSparkThemedTypography variant="h2" className={styles.quizSectionHeader}>
              {title}
            </CodeSparkThemedTypography>

            <CodeSparkThemedTypography variant="body1" className={styles.quizSectionBody}>
              {body}
            </CodeSparkThemedTypography>

            <div className={styles.foosWrapper}>
              {foos.map(({ src, alt }, i) => {
                return (
                  <div key={`quiz_foo_${i}`} className={styles.fooHead}>
                    <div className={styles.fooHeadImageWrapper}>
                      <img src={`${imgURL}/${src}`} alt={alt} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={`cell medium-12 large-6 ${styles.quizWrapper}`}>
            <Question selectedOption={selectedOption} onSelectOption={setSelectedOption} />

            <CtaButtonContainer align="center">
              <CtaButton
                type="primary"
                data-event-action="homepage-quiz"
                data-event-label={ctaLabel}
                onClick={handleClick}
                fullWidthMobile
              >
                {ctaLabel}
              </CtaButton>
            </CtaButtonContainer>
          </div>
        </div>
      </SectionPaddingSide>
    </SectionPaddingVertical>
  );
}

export default QuizSection;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Quiz/index.js